import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SigaDadosUsuario } from '../models/Interface/SigaDadosUsuario';
import { EsqueciMinhaSenha } from '../models/Interface/EsqueciSenha';
import { AtualizarContatoDTO } from '../models/AtualizarContatoDTO';

@Injectable({
  providedIn: 'root'
})
export class SigaService {

  static whatsappContato: string | null = null;

  constructor(private httpClient: HttpClient) { }

  getDadosLogin(login: string) {
    return this.httpClient.get(`${environment.urlApi}/siga/contato-cliente/${login}`);
  }

  getDadosUsuario(cdContato: number, cdCliente: number, login: string, senha: string) {
    return this.httpClient.get<SigaDadosUsuario>(`${environment.urlApi}/siga/dados-contato/${cdContato}/cliente/${cdCliente}?login=${login}&senha=${senha}`)
  }

  getEquipesSiga() {
    return this.httpClient.get(`${environment.urlApi}/siga/equipes-chamado`);
  }

  abreChamadoTenhoInteresse(dadosChamado) {
    return this.httpClient.post(`${environment.urlApi}/siga/chamado/tenho-interesse`, dadosChamado);
  }

  getTokenSigaSolicitante(idUsuario: number) {
    return this.httpClient.get(`${environment.urlApi}/siga/auth-token/${idUsuario}`);
  }

  redefinirSenhaSiga(esqueciSenha: EsqueciMinhaSenha) {
    return this.httpClient.post(`${environment.urlApi}/siga/esqueci-senha`, esqueciSenha);
  }

  verificaCpfWhatsapp(cdContato: number, cdCliente: number){
    return this.httpClient.get(`${environment.urlApi}/siga/verifica-cpf-celular?cdContato=${cdContato}&cdCliente=${cdCliente}`, { responseType: 'text' });
  }

  atualizarContato(dto: AtualizarContatoDTO){
    return this.httpClient.put(`${environment.urlApi}/siga/update-contato`, dto, { responseType: 'text' });
  }

}
